import NawsCommunication from './NawsCommunication';
import PluginInterface from './PluginInterface';

export default {
	NawsCommunication,
	PluginInterface,
};
